/**
 *
 * @param {number} x Number to format with commas
 * @returns {string} String, number with commas
 */

export function formatNumber(x, lang) {
  if (x === undefined || x === null) return 0;

  if (Number.isInteger(x) && x >= 1000000 && x % 1000000 === 0) {
    let newNumber = x / 1000000;
    return "" + newNumber + "M";
  }

  if (lang === "en") {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    let xString = x.toString();
    let tempString = xString.replace(".", "*");
    tempString = tempString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return tempString.replace("*", ",");
  }
}
